import styled from "styled-components";
import { Alert, Input, Select } from "antd";
import { ModalButtonYellow } from "common/modal/MoreModalButtons";

export const CustomInput = styled(Input)`
  ::placeholder {
    color: #707070;
  }
  &.ant-input {
    background-color: #f6f6f6;
  }
  width: 100%;
  height: 60px;
  margin: 10px 0px;
  font-size: 16px;
  color: black;
`;

export const CustomSelect = styled(Select)`
  width: 100%;
  height: 60px;
  margin: 10px 0px;
  font-size: 16px;
  color: black;
  &.ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
    height: 100%;
    justify-content: center;
    text-align: left;
    display: flex;
    align-items: center;
    padding: 0px 16px;
  }
  &.ant-select-single:not(.ant-select-customize-input)
    .ant-select-selector::placeholder {
    color: gray;
  }
  & .ant-select-arrow {
    margin-right: 8px;
  }
  &.ant-select-single.ant-select-show-arrow .ant-select-selection-search {
    justify-content: center;
    display: flex;
    align-items: center;
  }
`;

export const HskMessage = styled.div`
  text-align: left;
  margin: 4px 0px;
  font-size: 16px;
`;

export const AlreadyAMember = styled.p`
  font-size: 16px;
  font-weight: 500;
`;

export const Linkify = styled.a`
  font-size: 16px;
  font-weight: bold;
  text-decoration: underline;
`;

export const WrapMeUp = styled.div`
  display: inherit;
  margin-bottom: 10px;
  height: 23px;
`;

export const BigYellowButton = styled(ModalButtonYellow)`
  max-width: 510px;
  align-self: flex-start;
`;

export const ErrorMessage = styled(Alert)`
  margin: 10px auto;

  & .ant-alert-icon {
    color: red !important;
  }
  & .ant-alert-message,
  & .ant-alert-description {
    color: red !important;
    font-weight: 500;
    text-align: left;
  }
  & .ant-alert-message {
    font-size: 1.2rem;
  }
`;
